<script>
import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";

export default {
  props: {
    startsAt: {
      type: [Object, Date],
      required: true
    },
    hour: {
      type: Number,
      required: false,
      default: true
    }
  },

  methods: {
    decrease() {
      if (this.hour > this.from) {
        this.$emit("change", this.hour - 1);
      }
    },

    increase() {
      if (this.hour < this.to) {
        this.$emit("change", this.hour + 1);
      }
    }
  },

  computed: {
    availableHours: function() {
      return orderSchedulerHelper.nextAvailableHours(this.startsAt);
    },

    from: function() {
      return this.availableHours[0];
    },

    to: function() {
      return this.availableHours[this.availableHours.length - 1];
    }
  },

  filters: {
    hourFormat(hour) {
      return (hour < 10 ? "0" : "") + `${hour}h`;
    }
  },

  watch: {
    startsAt() {
      if (this.from > this.hour) {
        this.$emit("change", this.from);
      }
    }
  }
};
</script>

<template>
  <div class="hour-picker">
    <div @click="decrease">-</div>

    <span>{{ hour | hourFormat }}</span>

    <div @click="increase">+</div>
  </div>
</template>

<style lang="scss" scoped>
.hour-picker {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  span {
    color: $purple;
    background-color: rgba($purple, 0.05);
    border: 1px solid #ddd;
    border-left: none;
    border-right: none;
    padding: 10px;
    font-size: 16px;
  }
  > div {
    color: #af006b;
    border: 1px solid #ddd;
    padding: 10px 15px;
    user-select: none;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/HourPicker.vue